export function saveCryptoState(sessionState) {
  localStorage.setItem('sessionState', JSON.stringify(sessionState));
}
